export enum Brand {
  ESSENT = 'essent',
  ENERGIEDIRECT = 'energiedirect',
  SME = 'sme',
}
